import React from 'react';
import PropTypes from 'prop-types';
import { Price } from '../price';
import { getTranslationElement } from '../../../../helper/getTranslationElement';
import {Translation} from '../../../translation/translation';

export function ServiceCalloutFee({
    calloutFee,
    currencyIsoCode,
    loading,
}) {
    const labelExtraChildren = [
            <br
                key="ServiceCalloutFeeBr"
            />,
            <Translation
                translationKey="sidebar-service-callout-fee-disclaimer"
                className="service-callout-fee__disclaimer"
                key="ServiceCalloutFeeDisclaimer"
            />,
        ];
    return (
        <Price
            name="service-callout-fee"
            label={getTranslationElement('pdp-sidebar-service-callout-fee-label')}
            price={calloutFee}
            currencyIsoCode={currencyIsoCode}
            isSub={true}
            labelExtraChildren={labelExtraChildren}
            loading={loading}
        />
    );
}

ServiceCalloutFee.propTypes = {
    calloutFee: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
};
